/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { OptionOpenService } from "@ng-falcon/controls/option/option-open.service";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { SelectComponent } from '../select.component';
import {MatIcon} from "@angular/material/icon";
import {NgfOverflowDirective} from "@ng-falcon/ngf-overflow/ngf-overflow.directive";
import {PrefixDirective} from "@ng-falcon/controls/input-container/prefix.directive";
import {SuffixDirective} from "@ng-falcon/controls/input-container/suffix.directive";
import {InputContainerComponent} from "@ng-falcon/controls/input-container/input-container.component";

let nextUniqueId = 0;

@Component({
  selector: 'ngf-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIcon,
    NgfOverflowDirective,
    PrefixDirective,
    SuffixDirective,
    InputContainerComponent
  ]
})
export class SelectInputComponent implements OnInit, OnDestroy {
  @Input()
  placeholder: string;
  @Input()
  hasError = false;
  @Input()
  hasShadow = false;
  @Input()
  displayValue: string | null;
  @Input()
  isOpen = false;
  @Input()
  prefixIcon: string | null;
  @Input()
  disabled = false;
  @Input()
  hideInput = false;
  @Input()
  showOverflowTooltip = false;
  @Input()
  ariaLabel?: string;
  @Input()
  ariaLabelledby?: string;
  @Input()
  ariaDescribedby?: string;
  @Input()
  ariaValueDescription?: string;
  @Input()
  showClear = false;

  @Output()
  clear = new EventEmitter<Event>();

  readonly descId = `ngf-select-value-desc-${nextUniqueId++}`;

  get effectiveAriaDescribedby(): string | null {
    const parts = [this.ariaDescribedby, this.ariaValueDescription ? this.descId : null].filter(Boolean);
    return parts.length ? parts.join(' ') : null;
  }

  @Output()
  focusLost = new EventEmitter();

  @ViewChild('selectInput')
  selectInput: ElementRef;

  private sub = Subscription.EMPTY;

  constructor(private openService: OptionOpenService,
              @Optional() public select: SelectComponent) {
  }

  ngOnInit(): void {
    this.sub = this.openService.focus$.pipe(
      tap(() => this.focusInput())
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  handleBlur() {
    this.focusLost.emit();
  }

  handleClearClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.clear.emit(event);
  }

  private focusInput() {
    setTimeout(() => {
      this.selectInput.nativeElement.focus();
    }, 50);
  }

}
